module.exports = __webpack_public_path__ + "static/media/logoFERIT_hr.1148c2b7.png";